import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sellStartAddNew } from '../../actions/sell'
import { Navigate,Link } from 'react-router-dom'
import { fetchConToken } from '../../helpers/fetch'
import { Spin } from '../admin/panelComponents/productsPanel/Spin'
import { cartClean, cartDeleted } from '../../actions/auth'

export const CartFeedbackScreen = () => {
 
  const dispatch = useDispatch()

  
const querystring = window.location.search

const [mpResponse, setMpResponse] = useState([])
const payment = querystring.split("&")

let paymentID
payment.map(pay => {
  if(pay.includes("payment_id")){
    paymentID = pay.split("=")[1] 
  }
})


  useEffect(() => {
    localStorage.setItem('cart' , JSON.stringify([]))
    dispatch(cartClean())
   fetch( `https://api.mercadopago.com/v1/payments/${paymentID}`, {
      method: "GET",
      headers: {
          "authorization": "Bearer APP_USR-8805067731796101-040418-8d35ed3f37515dd35dcaf65cb405d46b-1101259524"
      }
  }).then(resp => resp.json())
    .then(res => setMpResponse(res))

  }, [querystring])

  useEffect(() => {
    if(mpResponse.status === "approved"){


      


      dispatch(sellStartAddNew(mpResponse))
    }
  }, [mpResponse])
  


  
  if(mpResponse.status === "approved"){


    
  
    const items = (mpResponse.additional_info.items)

    
    

    console.log(mpResponse)
  return (
    <div className='container _feedback'>
      
     {mpResponse.status === "approved" &&
      <div>
          <h1> GRACIAS POR SU COMPRA!</h1>

          <p>Numero de tramite: {paymentID}</p>
          <p>
            Pago  realizado con tarjeta {mpResponse.payment_method_id}: ********
          {mpResponse.card.last_four_digits}
          </p>

          Puede ver el seguimiento de su compra en su perfil

          <div className='row buttons'>

            <div className='col-2'>

              <Link to="/">

                  <div className='btn_blue '>
                      Volver al inicio
                  </div>
              </Link>
            </div>
            <div className='col-2'>

              <Link to="/perfil">

                  <div className='btn_blue '>
                     ir al Perfil
                  </div>
              </Link>
            </div>
            

          </div>
      </div>
    }



    
    </div>
    
  )

}else if(mpResponse.message){

 return (
    <Navigate to="/" />
 )



}else{

 return <Spin />
}



}
